<template>
    <div>
<!--        <br>ARR:{{arr}}
        <br>Vals:{{vals}}
        <br>MinMax:{{minLimit}} {{maxLimit}}-->
        <label v-if="smalltitle" class="small-label" >{{title}}</label>
        <label v-else>{{title}}</label>
        <div class="is-flex is-flex-wrap-nowrap slider is-align-items-center">
            <div class="value-slider left pr-4">
                {{fmt(minLimit)}}
            </div>
            <b-field>
                <b-slider
                    @dragend="quant=0,submit()"
                    v-model="vals"
                    :min="minLimit"
                    :max="maxLimit"
                    :step="step"
                    :tooltip="true"
                    :custom-formatter="(val) => this.fmt(val)"
                    
                >
                </b-slider>
            </b-field>
            <div class="value-slider right pl-4">
                {{fmt(maxLimit)}}
            </div>
        </div>
        <div class="columns is-flex">
            <div class="column is-6-mobile">
                <template  v-if="increaseButton">
                    <div class="is-flex is-align-items-center">
                        <b-button @click="updateValueClick('decrease', 0)" class="btn-increase is-link">-</b-button>
                        <b-button @click="updateValueClick('increase', 0)" class="btn-increase is-link">+</b-button>
                    </div>
                </template>
            </div>
            <div class="column is-6-mobile">
                <template  v-if="increaseButton">
                    <div class="is-flex is-align-items-center is-justify-content-flex-end">
                        <b-button @click="updateValueClick('decrease', 1)" class="is-link btn-increase">-</b-button>
                        <b-button @click="updateValueClick('increase', 1)" class="is-link btn-increase">+</b-button>
                    </div>
                </template>
            </div>
        </div>

        <div v-if="!nobuttons" class="field field-radio buttons mt-5 is-align-items-center filtered-quartile py-2">
            <span class="is-size-7 mr-5 mb-2 m-b-0-tablet has-text-weight-bold">Filter by Quartile</span>
            <b-field>
                <div>
                    <b-radio-button @input="getQuantile('0-25')"  v-model="quant" :native-value="1">
                        <span>1st</span>
                    </b-radio-button>
                </div>
                <div>
                    <b-radio-button @input="getQuantile('25-50')" v-model="quant" :native-value="2">
                        <span>2nd</span>
                    </b-radio-button>
                </div>
                <div>
                    <b-radio-button @input="getQuantile('50-75')" v-model="quant" :native-value="3">
                        <span>3rd</span>
                    </b-radio-button>
                </div>
                <div>
                    <b-radio-button @input="getQuantile('75-100')" v-model="quant"
                                    :native-value="4">
                        <span>4th</span>
                    </b-radio-button>
                </div>
            </b-field>
        </div>
    </div>
</template>

<script>

import axios from "axios"
export default {
    name: 'Quantile',
    props: {
        nobuttons:Boolean,
        title: String,
        maxLimit: Number,
        minLimit: Number,
        smalltitle: Boolean,
        clear: Boolean,
        suffix:String,
        arr: Array,
        reverse:Boolean,
        percentileType:String,
        step:Number,
        fixed:Number,
        format:String,
        increaseButton: Boolean,
        increaseValue: Number
    },
    data() {
        return {
            //pauseForClear:false,
            percentile:false,
            max: 0,
            min: 0,
            quant: 0,
            vals:[]
        }
    },
    methods: {

        fmt(x){
            if(this.format=="percent"){
                return x.toFixed(this.fixed)+"%"
            }
            else if(this.format=="pounds"){
                return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(x/1000000).slice(0, -1) + "m"
            }
            return x.toFixed(this.fixed)

        },

        updateValueClick(type, index) {
            let increaseValueEls = document.querySelectorAll('.increase-value')
            let tooltipContent = increaseValueEls[0].querySelectorAll('.tooltip-content')
            tooltipContent[index].style.display = 'block'
            if (!this.vals[index] && index === 0) this.vals[index] = this.minLimit
            if (!this.vals[index] && index === 1) this.vals[index] = this.maxLimit
            let newVal = null
            if(type === 'increase') {
                newVal = this.vals[index] <= this.maxLimit ? this.vals[index]+=this.increaseValue : this.vals[index] = this.maxLimit
            } else {
                newVal = this.vals[index] >= this.minLimit ? this.vals[index]-=this.increaseValue : this.vals[index] = this.minLimit
            }
             this.$set(this.vals, index, newVal)
             this.quant = 0
             this.submit()
        },
        submit(){
            if(this.vals[0].toFixed(1) == this.minLimit.toFixed(1) && this.vals[1].toFixed(1) == this.maxLimit.toFixed(1)){
                this.$emit('slider-change', [])
                this.vals = [this.minLimit, this.maxLimit,""]
                this.quant = ""
            }
            else{
                this.$emit('slider-change', [this.vals[0], this.vals[1], this.quant])
            }
        },
        getQuantile(n){
            //this.pauseForClear=false
            let s = this.$store.state.search.lastSearch.text
            if(this.$store.state.search.lastSearch.code){
                s = this.$store.state.search.lastSearch.code
            }
            let params = {
                search: s,
                native: this.$store.state.currency,
                percentile: n,
                precentiletype:this.percentileType
            }

            //Object.assign(params, this.$store.state.search.filter)
            //Object.assign(params, this.$store.state.search.provisionalFilters )
            params[this.percentileType] = []

            axios.get('/search/' + this.$store.state.search.lastSearch.type, {
                params: params
            })
            .then((response) => {
                const q = response.data.pop()
                this.vals = [
                    parseFloat(q.bottom),
                    parseFloat(q.top),
                    this.quant
                ];
                this.submit()
            })
            .catch(() => {
            })

        }
    },
    watch:{
        clear:function(){
            this.vals = [this.minLimit, this.maxLimit,""]
            this.quant = ""
        },
        arr:{
            handler(a,b){
                if(!(a[0] && b[0])){
                    this.vals = [
                        a[0],
                        a[1],
                        a[2]
                    ]
                    this.quant = a[2]
                }
            },
            deep:true,
        }
    }
}
</script>
<style lang="scss" scoped>
.btn-increase {
    width: 32px;
    height: 32px;
    padding: 5px;
    margin: 0 2px;
}
</style>